module.exports = __webpack_public_path__ + "img/website-demo.591f088c.png";